import { Model, belongsTo } from 'miragejs';

export default Model.extend({
  contest: belongsTo('contest-form-field', { inverse: 'formFields' }),
});
